import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';
import { mapActions, mapGetters, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
  ],
  computed: {
    ...mapState('profile', ['userAffiliations', 'isUCAffilSet']),
    ...mapGetters('app', ['collegeAffiliationEnabled']),
  },
  methods: {
    ...mapActions('profile', ['getUserAffiliations']),
    ...mapActions('popup', [
      'setCurrentSmallPopup', 'setCurrentPopup', 'setCurrentPopupOptions',
    ]),
    showAffiliationsPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(MODALS.COLLEGE_AFFILIATION);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_PUBLIC_PROFILE_INFO);
    },
  },
  mounted() {
    if (!this.collegeAffiliationEnabled) return;
    this.loaderAdd();
    this.getUserAffiliations()
      .then(() => this.loaderRemove())
      .catch(() => this.loaderRemove());
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/public-profile-widget/public-profile-widget.js